require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./counter-redux-cycle.json") })
        }
      }, "path---counter-redux-cycle");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---counter-redux-cycle!./.cache/json/counter-redux-cycle.json
// module id = 374
// module chunks = 231608221292675